// extracted by mini-css-extract-plugin
export default {"root":"ZeroWasteFee_root__O8Crx"};